import React, { useState, useEffect, useRef } from 'react'

import Checkbox from '../../checkbox'

import * as S from '../styles'

import IProps from './props'
import ICity from '../../../../interfaces/city'

import { useClickOutside } from '../utils'

const CitiesPopup = ({
  onApply,
  onClose,
  selectedLocations,
  cityList,
}: IProps) => {
  const [selectedCities, setSelectedCities] = useState<ICity[]>([])

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const cities: ICity[] = selectedLocations.flatMap((location) => location.cities.map((city) => ({
      name: city,
      state: location.state,
    })))
    setSelectedCities(cities)
  }, [selectedLocations])

  const handleCheckCity = (cityName: string, state: string) => {
    const cityExists = selectedCities.some(
      (city) => city.name === cityName && city.state === state,
    )

    if (cityExists) {
      setSelectedCities(
        selectedCities.filter(
          (city) => !(city.name === cityName && city.state === state),
        ),
      )
    } else {
      setSelectedCities([...selectedCities, { name: cityName, state }])
    }
  }

  const handleApply = () => {
    onApply(selectedCities)
    onClose()
  }

  useClickOutside(
    containerRef,
    'city',
    'cities',
    () => {
      onApply(selectedCities)
    },
    handleApply,
  )

  return (
    <S.Container ref={containerRef} className="cities-popup">
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
      {cityList.map((city) => (
        <Checkbox
          key={`city-list-${city.id}`}
          id={city.name}
          label={city.name}
          checked={selectedCities.some((c) => c.name === city.name)}
          onCheck={() => handleCheckCity(city.name, city.state)}
        />
      ))}
      <S.ApplyButton onClick={handleApply}>Aplicar</S.ApplyButton>
    </S.Container>
  )
}

export default CitiesPopup
